import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const {
  appUrl,
  apiUrl,
  restApiUrl,
  printerServiceUrl,
  isDev,
  version,
  auth0Audience,
  auth0Region,
  auth0Scope,
  auth0Domain,
  auth0ClientId,
} = publicRuntimeConfig

// Making explicit export for each variable. Otherwise, when
// I import this variables, eslint complains about they
// not being exported in this module.
export {
  appUrl,
  apiUrl,
  restApiUrl,
  printerServiceUrl,
  isDev,
  version,
  auth0Audience,
  auth0Region,
  auth0Scope,
  auth0Domain,
  auth0ClientId,
}
